import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue"

import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import {onMounted, reactive, ref} from "vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogGrid from "@/shared/ui/SogGrid.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import ShoppingCartItemComponent from "@/modules/ShoppingCart/components/ShoppingCartItemComponent.vue";
import {computed} from "vue";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";


export default /*@__PURE__*/_defineComponent({
  __name: 'shoppingCartListComponent',
  setup(__props) {

const _grid = ref<InstanceType<typeof SogGrid> | null>(null)

const _items = reactive([{
  id: "",
  productType: "",
  product: "",
  count: 0,
  grossPrice: 0,
  amount: 0,
  manufacturer: "" as string,
  item: undefined as ShoppingCartItem | undefined
}])
const _router = useRouter()
const _amount = ref(0)


const _shoppingCartStore = useShoppingCartStore();


async function onDelete(id: string) {
  _shoppingCartStore.removeItem(id)
  refresh();
}

/*
async function commandClick(args: any) {
  if (args?.rowData?.id) {
    _shoppingCartStore.removeItem(args.rowData.id)
    refresh();
  }
  args.cancel = true;
}
*/

async function init(route: RouteLocationNormalizedLoaded) {
  const shoppingCart = useShoppingCartStore();
  const sector = route.params.sector as string;
  if (sector === "purchase") {
    await shoppingCart.initPurchase();
  }
  refresh()
}

function refresh() {
  _items.length = 0;
  const t_array = _shoppingCartStore.getItems();
  t_array.forEach(t => _items.push({
      id: t.id,
      productType: t.insuranceTypeName,
      product: t.productDescription,
      manufacturer: t.manufacturerName,
      count: t.count,
      grossPrice: t.grossPrice,
      amount: t.amount,
      item: t
    })
  )

  _amount.value = _shoppingCartStore.amount();

  _grid.value?.refresh();
}

onMounted(async () => {
  const route = useRoute();
  await init(route);
})


onBeforeRouteUpdate(async (to) => {
  await init(to);
})

const _isInvoiced = computed(() => {
  return _shoppingCartStore.currentShoppingCart.isInvoiced
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card-without-title" }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Einkaufswagen ist leer. ", -1)
        ]))]),
        _: 1
      }, 512), [
        [_vShow, _items.length===0]
      ]),
      _withDirectives(_createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogFlexRow, { style: {"justify-content":"flex-start"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_items, (item) => {
                return (_openBlock(), _createBlock(ShoppingCartItemComponent, {
                  key: item,
                  class: "sog-card-without-title",
                  item: item,
                  "is-invoiced": _isInvoiced.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActions, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-delete",
                          onClick: ($event: any) => (onDelete(item.id))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["item", "is-invoiced"]))
              }), 128))
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogFlexRow, { style: {"justify-content":"end"} }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createTextVNode(" Gesamtsumme: ", -1)),
              _createVNode(SogDataLabel, {
                "value-type": _unref(SogDataLabelValueType).Money,
                value: _amount.value
              }, null, 8, ["value-type", "value"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _isInvoiced.value]
          ]),
          _createVNode(SogFlexRow, { style: {"justify-content":"end"} })
        ]),
        _: 1
      }, 512), [
        [_vShow, _items.length>0]
      ]),
      _withDirectives(_createVNode(SogCardActions, { style: {"justify-content":"end"} }, {
        default: _withCtx(() => [
          _createVNode(SogFlexRow, { style: {"justify-content":"flex-end"} }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-cart-check",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(_router).push('cashpoint')))
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Zur Kasse gehen ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _items.length>0]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _items.length>0]
      ])
    ]),
    _: 1
  }))
}
}

})